import React,{useState} from "react";
import "./BonusOffer.css";
import CustomModal from "./CustomModal";

const BonusOffer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
    const openModal = () => {
      setIsModalOpen(true);
    };
  
    const closeModal = () => {
      setIsModalOpen(false);
    };
  return (
    <><div className="bonuses-wrapper">
      <div className="bonuses-header">
        <h2>Limited Time Offer – Try our course for 1 week for ₹599/-</h2>
      </div>
      <div className="bonuses-content">
        <p>
          Experience the power of practical learning with our digital marketing course.
          For just ₹599, you’ll get one full week of access to insightful lectures, expert resources, and hands-on activities
          designed to jumpstart your career in digital marketing. Whether you're a beginner or looking to upskill, this offer
          is the perfect way to explore our course without commitment.
        </p>
        <button className="bonus-cta" onClick={openModal}>Try Our Course Today</button>
      </div>
    </div><CustomModal isOpen={isModalOpen} onClose={closeModal} /></>
  );
};

export default BonusOffer;
